import React, { useState, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function QRGenerator() {
  const [text, setText] = useState("https://app20.co/");
  const qrRef = useRef<HTMLDivElement>(null);

  const downloadQR = () => {
    if (!qrRef.current) return;
    const canvas = qrRef.current.querySelector("canvas");
    if (!canvas) return;

    const url = canvas.toDataURL();
    const a = document.createElement("a");
    a.href = url;
    a.download = "qr-code.png";
    a.click();
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>QR Code Generator</h2>

      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter text or URL"
        style={{
          padding: "10px",
          width: "300px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          marginBottom: "20px"
        }}
      />

      {/* QR Code container */}
      <div ref={qrRef} style={{
        margin: "0 auto 20px auto",
        background: "#ffffff",
        padding: "20px",
        width: "fit-content",
        borderRadius: "10px",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
      }}>
        <QRCodeCanvas
          value={text || " "}
          size={250}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
          includeMargin={true}
        />
      </div>

      <button
        onClick={downloadQR}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          transition: "background-color 0.2s"
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#007bff"}
      >
        Download QR
      </button>

      <div style={{ marginTop: "40px", textAlign: "left", maxWidth: "400px", margin: "40px auto 0 auto" }}>
        <h3>Common Uses:</h3>
        <ul style={{ lineHeight: "1.6" }}>
          <li>Payment QR</li>
          <li>Login / Auth QR</li>
          <li>Product page QR</li>
          <li>App download QR</li>
          <li>Event ticket QR</li>
        </ul>
      </div>
    </div>
  );
}
